import styled from "styled-components";

export const MainContainer = styled.main`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;

export const SectionContainer = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: ${({ theme }) => theme.zIndex.appSection};

  @media screen and (forced-colors: active),
    screen and (forced-colors: none) {
    display: block;
    flex: auto;
  }
`;

export const MainContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
